import { useEffect, useState } from "react";

import { ProductFeatures } from "../types";
import { getProductFeatures } from "../api";
import { redirectToMainPage } from "../utils";

export function useLoadProductFeatures(productId: string): ProductFeatures | null {
    const [features, setFeatures] = useState<ProductFeatures | null>(null);

    useEffect(() => {
        const controller = new AbortController();

        getProductFeatures(productId, controller.signal)
            .then(setFeatures)
            .catch(error => {
                if (error?.name === "AbortError") return;
                console.error("Failed to load product features", error);
                redirectToMainPage();
            });

        return () => controller.abort();
    }, [productId]);

    return features;
}
